import * as httpx from "httpx"
import * as events from "./events"
import { CancellablePromise } from "real-cancellable-promise"
import {
	DocumentSearchRequest,
	DocumentSearchResponse,
	DocumentFindResponse,
	DocumentPatchRequest,
	DocumentPatchResponse,
} from "brandguard/brandguard.document_pb"

export namespace requests {
	export function search(d: Partial<DocumentSearchRequest> = {}): DocumentSearchRequest {
		return {
			offset: 0n,
			queues: [],
			uploaded_by: [],
			deprecated_uploaded_by: "",
			brand_id: "",
			limit: 10n,
			observation: [],
			approved: [],
			...d,
		}
	}
}

export function search(
	bid: string,
	req: DocumentSearchRequest,
	...options: httpx.option[]
): CancellablePromise<DocumentSearchResponse> {
	return httpx
		.get<DocumentSearchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/approvallog`, req, ...options)
		.then((resp) => ({
			...resp,
			items: (resp.items || []).map((item) => ({ media: item.media, event: events.zero(item.event), pages: item.pages })),
		}))
}

export function find(id: string, bid: string, ...options: httpx.option[]): Promise<DocumentFindResponse> {
	return httpx
		.get<DocumentFindResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/approvallog/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages,
		}))
}

export function patch(
	id: string,
	bid: string,
	req: DocumentPatchRequest,
	...options: httpx.option[]
): Promise<DocumentPatchResponse> {
	return httpx
		.patch<DocumentPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/approvallog/${id}`, req, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages,
		}))
}

export function destroy(bid: string, id: string, ...options: httpx.option[]): Promise<DocumentPatchResponse> {
	return httpx
		.destroy<DocumentPatchResponse>(`${httpx.urlstorage.host()}/brands/${bid}/bg/document/approvallog/${id}`, {}, ...options)
		.then((resp) => ({
			media: resp.media,
			event: events.zero(resp.event),
			pages: resp.pages,
		}))
}
